import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getStore, saveStore, storeToggle, getStoreStates,getTownList } from '../../actions/store';
import FullPageLoader from "../common/fullPageLoader";
import Modal from 'react-responsive-modal';
import Select from 'react-dropdown-select';
import {withRouter} from 'react-router-dom';
import axios from "axios";
import SimpleReactValidator from 'simple-react-validator';
import { filterDefault, closeDefault } from '../common/MangoIcons'

const storeStatesUrl = `${process.env.REACT_APP_API_URL}mobileshop/catalog/get-store-list`;
const storePincodeUrl = `${process.env.REACT_APP_API_URL}mobileshop/catalog/get-pincode-stores`;

class Store extends React.Component {
  constructor() {
    super()
    this.state = {
      isOpen: false,
      stateData: [],
      stateSelected: null,
      stateLoading: false,
      newStoreList: [],
      store_pin: "",
      newStoreCity : false,
    }
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    if (this.props.stores === null) {
      
     // this.props.getStore(this.props.connection_id)
      this.props.getTownList(this.props.connection_id)
    }
   // this.props.getStoreStates(this.props.connection_id)
    // this.setState({ stateData : this.props.storeStates })
    // this.setState({
    //   stateSelected: [{
    //     ASM_STATE_CD: this.props.storeStates[0].ASM_STATE_CD,
    //     ASM_STATE_NAME: this.props.storeStates[0].ASM_STATE_NAME
    //   }],
    // })
    // 
  }

  getStoreByState(state_cd) {
    const { connection_id } = this.props
    
    this.setState({ stateLoading: true }, () => {
      axios.get(storeStatesUrl, {
        params: {
          connection_id,
          state_code: state_cd[0].ASM_STATE_CD
        },
      }).then((res) => this.setState({
        newStoreList: res.data.results.store_list,
        stateLoading: false
      }));
    })
  }


  getStoreByTown(town) {
    const { connection_id } = this.props
    
    this.setState({ stateLoading: true, newStoreCity: false }, () => {
      axios.get(storeStatesUrl, {
        params: {
          connection_id,
          state_code: town[0].ASM_TOWN_NAME
        },
      }).then((res) => this.setState({
        newStoreList: res.data.results.store_list,
        stateLoading: false
      }));
    })
  }

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.validator.allValid()) {
      
      // const { connection_id } = this.props
      // const options = {
      //   connection_id, user_data: {
      //     cons_mobile_no: this.props.userDetails.COM_CONSUMER_MOBILE_NO,
      //     ...this.state
      //   }
      // }
      // this.props.updateUserAddr(options)
      // setTimeout(() => {
      //   this.props.history.goBack()
      // }, 5000)
    const { connection_id } = this.props
    this.setState({ stateLoading: true }, () => {
      axios.get(storePincodeUrl, {
        params: {
          connection_id,
          query: this.state.store_pin
        },
      }).then((res) => {
        //
        this.setState({
        newStoreList: res.data.results.store_list,
        stateLoading: false
      })});
    })
    
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  }

  // handleChange(event) {
  //   this.setState({ [event.target.id]: event.target.value });
  // }

  setStore(store) {
    //this.setStore()
    const {connection_id, web_session_trans_id} = this.props
    
    // this.setState({ open: false });
    this.props.saveStore(store, connection_id, web_session_trans_id)
  }

  closeCondition() {
    if (this.props.selectedStore === null) {
      return null
    }
    else return this.props.storeToggle()
  }

  
  render() {
    // 
    const { loading, selectedStore, stores, storeStates, storeImage, stylesheet_properties } = this.props;
    // 
    if (loading || storeStates === null) {
      return <FullPageLoader />
    }

    const ReactDropDownStyle = {
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      borderBottom: "1px solid #000000",
      borderRadius: "0px",
      "&:hover" : {
        borderColor: "#000000"
      }
    }
    
  const closeIcon = (
    <svg fill="white" viewBox="0 0 30 20" width={40} height={40}>
      <path
        fillRule="evenodd"
        d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
        clipRule="evenodd"
      ></path>
    </svg>
  )

    if (this.props.history && this.props.history.location && this.props.history.location.pathname === '/profile/change-password' ){
     // 
      return null
    }

    return (
      <Modal open={this.props.open} onClose={() => this.closeCondition()} center  showCloseIcon={false} classNames={{ modal: 'storeModal' }}>
        {/* <select className="custom-select" id="inputGroupSelect02" >
                      <option defaultValue>Choose...</option>
                      {stores.map((store) => {
                        return(
                          <option key={store.ASM_ASSOC_CD} value={store.ASM_ASSOC_CD} onClick={() => this.setStore(store)}>{store.ASM_NAME}</option>
                        ) 
                      })}
                    </select> */}
        {/* <div className="store">
          {stores.map((store) => {
            return (
              <div key={store.ASM_ASSOC_CD} className="store-list">
                <label>
                  <input className="checkbox_animated" defaultChecked={selectedStore && selectedStore.ASM_ASSOC_CD === store.ASM_ASSOC_CD ? true : null} type="checkbox" name={store.ASM_ASSOC_CD} onClick={() => this.setStore(store)} /> {store.ASM_STORE}</label>
              </div>
            )
          })}
        </div> */}
        <div className="store-header" style={{background: stylesheet_properties.APS_TOP_BAR_COLOR_CODE}}>
          <label>our stores are open now</label>
        </div>
        <div className="store-container">
          <div className="store-item-a">
            <img src={storeImage ? storeImage[0].APC_ELEMENT_CONTENT : require('../../assets/images/store.png')} width={350} />
          </div>
          <div className= {this.state.newStoreCity == true ? 'store-item-parent store-item-b' : 'store-item-b' } >
            <form className="theme-form mt-4" onSubmit={(e) => this.handleSubmit(e)}>
              <div className="form-row">
                <div className="col-md-12 pb-3">
                  {/* <label htmlFor="review">Pin/Zip Code</label> */}
                  {/* <input placeholder="Enter Pin code" className="form-control" maxLength="6" pattern="\d*" */}
                  {/* // value={this.state.ship_pin} */}
                  {/* // onChange={(e) => this.handleChange(e)} */}
                  {/* // id="ship_pin" type="text" autocomplete="new" /> */}
                  {/* {this.validator.message('ship pin', this.state.ship_pin, 'required|numeric')} */}
                  {/* <input placeholder="Enter Pin code" className="form-control" maxLength="6" pattern="\d*"
                        value={this.state.store_pin}
                        onChange={(e) => this.handleChange(e)}
                        id="store_pin" type="text" autocomplete="new" />
                      {this.validator.message('Store Pincode', this.state.store_pin, 'required|numeric|min:6|max:6')} */}

                  {/* <Select
                    className="reactStoreSelect"
                    labelField='ASM_STATE_NAME'
                    valueField='ASM_STATE_CD'
                    noDataRenderer={({ props, state, methods }) => <div className="loading-cls"></div>}
                    loading={this.state.stateLoading}
                   searchBy='ASM_STATE_NAME'
                    options={this.state.stateData}
                    placeholder={this.state.stateSelected && this.state.stateSelected[0].ASM_STATE_NAME || 'State Name'}
                    values={[]}
                    autoFocus={false}
                    searchable={false}
                    onDropdownOpen={() => this.setState({ stateData: this.props.storeStates })}
                    onChange={(value) => {
                      this.getStoreByState(value)
                      this.setState({ stateSelected: value })
                    }}
                    style={ReactDropDownStyle}
                  /> */}

                  <Select
                    className="reactStoreSelect"
                    labelField='ASM_TOWN_NAME'
                    valueField='ASM_TOWN_CD'
                    noDataRenderer={({ props, state, methods }) => <div className="loading-cls"></div>}
                    loading={this.state.stateLoading}
                    searchBy='ASM_TOWN_NAME'
                    options={this.state.stateData}
                    placeholder={this.state.stateSelected && this.state.stateSelected[0].ASM_TOWN_NAME || 'Select a city'}
                    values={[]}
                    autoFocus={false}
                    searchable={false}
                    onDropdownOpen={() => {
                      this.setState({ 
                        stateData: this.props.storeStates, 
                        newStoreCity : true 
                      })
                      
                    }}
                    onChange={(value) => {
                      this.getStoreByTown(value)
                      this.setState({ stateSelected: value })
                    }}
                    style={ReactDropDownStyle}
                  />
                </div>
                {/* <div className="col-md-12 pb-3">
                  <button className="btn btn-solid" type="submit" style={{width: "100%"}}>Click to view store list</button>
                </div> */}
                {/* <div className="col-md-6 pb-3">
                  <label htmlFor="review">Pin/Zip Code</label>
                  <input placeholder="Enter Pin code" className="form-control" maxLength="6" pattern="\d*"
                    value={this.state.ship_pin}
                    onChange={(e) => this.handleChange(e)}
                    id="ship_pin" type="text" autocomplete="new" disabled={true} />
                  {this.validator.message('ship pin', this.state.ship_pin, 'required|numeric')}
                </div> */}
              </div>
            </form>
            {
            this.state.stateLoading ? 
              <p>Getting stores...</p>
            : <div className={this.state.newStoreList.length > 0 ? 'store-list-parent' : '' } >{
              this.state.newStoreList && this.state.newStoreList.map((store, index) => {
                return (
                  // <div key={store.ASM_ASSOC_CD} className="store-list">
                  //   {index < 1 ? <div className="store-list-label">Choose a store to begin with ({this.state.newStoreList.length}) </div> : null}
                  //   <label>
                  //     {/* <input className="checkbox_animated" defaultChecked={selectedStore && selectedStore.ASM_ASSOC_CD === store.ASM_ASSOC_CD ? true : null} type="checkbox" name={store.ASM_ASSOC_CD} onClick={() => this.setStore(store)} /> {store.ASM_STORE} */}
                  //     <span name={store.ASM_ASSOC_CD} style={selectedStore && selectedStore.ASM_ASSOC_CD === store.ASM_ASSOC_CD ? { fontWeight: "bold", borderBottom: "1px solid #000", paddingBottom: 5 } : { fontWeight: "normal" } } onClick={() => this.setStore(store)}>
                  //       {store.ASM_STORE}
                  //     </span>
                  //   </label>
                  // </div> ASM_NAME FND_ASSOC_CD
                  <div key={store.ASM_ASSOC_CD} className="store-list">
                  {index < 1 ? <div className="store-list-label">Choose a city to begin shopping ({this.state.newStoreList.length}) </div> : null}
                  <label>
                    {/* <input className="checkbox_animated" defaultChecked={selectedStore && selectedStore.ASM_ASSOC_CD === store.ASM_ASSOC_CD ? true : null} type="checkbox" name={store.ASM_ASSOC_CD} onClick={() => this.setStore(store)} /> {store.ASM_STORE} */}
                    <span name={store.ASM_ASSOC_CD} style={selectedStore && selectedStore.ASM_ASSOC_CD === store.ASM_ASSOC_CD ? { fontWeight: "bold", borderBottom: "1px solid #000", paddingBottom: 5 } : { fontWeight: "normal" } } onClick={() => this.setStore(store)}>
                      {store.ASM_STORE}
                    </span>
                  </label>
                </div>
                )
              }) 
              }</div>
              // <p>Get stores in your area. Enter your Pincode.</p>
            }
          </div>
        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  loading: state.store.loading,
  error: state.store.error,
  stores: state.store.stores,
  selectedStore: state.store.selectedStore,
  storeStates: state.store.storeStates,
  open: state.store.isOpen,
  connection_id: state.tenant.connection_id,
  stylesheet_properties: state.tenant.stylesheet_properties,
  web_session_trans_id: state.user && state.user.web_session_trans_id || "",
  storeImage: state.tenant.header_and_store_content.filter(item => item.APC_ELEMENT_ID === "Store Image") || null,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getStore,
      saveStore,
      storeToggle,
      getStoreStates,
      getTownList
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Store));